import { oneLine } from 'common-tags';

import styles from './Grid.module.css';

import type { FunctionComponent } from 'react';
import type { TypeGridProps } from './types';

/**
 * Grid
 */
export const Grid: FunctionComponent<TypeGridProps> = ({
  className = '',
  style,
  outline = true,
  xxs = 1,
  xs = 2,
  sm = 3,
  md = 4,
  lg = 6,
  xl,
  xxl,
  refProp,
  children,
}: TypeGridProps) => (
  <div
    className={oneLine`
      ${styles['c-grid']}
      ${outline ? styles['c-grid--outline'] : ''}
      grid-cols-${xxs}
      xs:grid-cols-${xs}
      sm:grid-cols-${sm}
      md:grid-cols-${md}
      lg:grid-cols-${lg}
      ${xl ? `xl:grid-cols-${xl}` : ''}
      ${xxl ? `2xl:grid-cols-${xxl}` : ''}
      ${className}
    `}
    ref={refProp}
    style={style}
  >
    {children}
  </div>
);
